import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class AccountingCategorySelectedValues  {
    _originalTypeClassName = "zERP.BO.AccountingCategorySelectedValues";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
AccountingCategorySelectedValues.translate = translateService;
}
this.Values = [];
this.Id = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Category:any;
Values:any;
FirstSelectedValue:any;
static setCategory = ($this, value) => {
var oldValue = $this.Category;
$this.Category = value;
if (value != null) {
}
}
static setValues = ($this, items) => {
                if (items == null) items = [];
                if ($this.Values == null) $this.Values = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Values.length > 0) {
                    Domain.AccountingCategorySelectedValues.removeValues($this, $this.Values[0]);
                }

                Domain.AccountingCategorySelectedValues.addManyValues($this, copyItems);
            }
static addManyValues = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.AccountingCategorySelectedValues.addValues($this, items[i]);
                }
            }
static addValues = ($this, item) => {
                if ($this.Values == null) $this.Values = [];
                if (item == null || $this.Values.indexOf(item) > -1) return;
                $this.Values.push(item);
}
static addRangeValues = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.AccountingCategorySelectedValues.addValues($this, item));
            }
static removeValues = ($this, item) => {
                if ($this == null || $this.Values == null || $this.Values.indexOf(item) === -1) return;
                var _index = $this.Values.indexOf(item);
                $this.Values.splice(_index, 1);
}
static clearValues = ($this) => { $this.Values = null; }
static setFirstSelectedValue = ($this, value) => {
var oldValue = $this.FirstSelectedValue;
$this.FirstSelectedValue = value;
if (value != null) {
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}